import { useState } from "react";

import { IAction } from "./actions";


export const useAction = <ParamsT, ResultT>(): IAction<ParamsT, ResultT> => {

    const [isActive, setIsActive] = useState<boolean>(false);
    const [params, setParams] = useState<ParamsT>();
    const [result, setResult] = useState<ResultT | null>(null);
    const [onCompleteStart, setOnCompleteStart] = useState<(result?: ResultT | null) => void>();

    const start = (params: ParamsT, onComplete?: (result?: ResultT | null) => void) => {
        setResult(null);
        setParams(params);
        setIsActive(true);
        setOnCompleteStart(!onComplete ? undefined : () => onComplete);
    };

    const complete = (result: ResultT) => {
        setResult(result);
        setIsActive(false);      

        if (!!onCompleteStart) {
            onCompleteStart(result);
        }

        setOnCompleteStart(undefined);
    };

    const cancel = () => {
        setResult(null);
        setIsActive(false);
        setOnCompleteStart(undefined);
    };

    return {
        isActive,
        start,
        complete,
        cancel,
        params,
        result
    }; 

};